import { render, staticRenderFns } from "./CashierResetPassword.vue?vue&type=template&id=6639e58c"
import script from "./CashierResetPassword.vue?vue&type=script&lang=js"
export * from "./CashierResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports